import { useState } from 'react';
import { motion } from 'framer-motion';

interface JoinRoomPanelProps {
  onJoinRoom: (code: string) => void;
}

export function JoinRoomPanel({ onJoinRoom }: JoinRoomPanelProps) {
  const [code, setCode] = useState('');
  const recentCodes = ['TAMB99', 'PLAY12', 'GOLD77', 'ROOM45'];

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (code.trim().length >= 4) {
      onJoinRoom(code.toUpperCase().trim());
    } else {
      alert('Please enter a valid room code (at least 4 characters).');
    }
  };

  const handleRecentClick = (recentCode: string) => {
    setCode(recentCode);
  };

  return (
    <div className="glass rounded-3xl p-5 border border-white/10 shadow-glow-lg flex flex-col justify-between h-full text-left">
      <div>
        <h3 className="font-display text-base font-black tracking-wider text-amber-300 uppercase mb-4">
          Join with Code
        </h3>

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Room Code Input */}
          <div className="space-y-1">
            <label className="text-[10px] font-bold uppercase tracking-wider text-surface-400">
              Room Code
            </label>
            <input
              type="text"
              value={code}
              onChange={(e) => setCode(e.target.value.toUpperCase())}
              placeholder="e.g. ABC123"
              maxLength={8}
              className="w-full px-4 py-3 text-lg text-center rounded-xl bg-slate-950/40 border border-white/5 text-white placeholder-slate-600 font-black tracking-widest focus:outline-none focus:border-purple-500/50 focus:ring-1 focus:ring-purple-500/30 transition-all duration-300 shadow-inner"
            />
          </div>

          {/* Recent Rooms list */}
          <div className="space-y-2 pt-2">
            <label className="text-[10px] font-bold uppercase tracking-wider text-surface-500 block">
              Recent Room Codes
            </label>
            <div className="flex flex-wrap gap-1.5">
              {recentCodes.map((recentCode) => (
                <button
                  key={recentCode}
                  type="button"
                  onClick={() => handleRecentClick(recentCode)}
                  className="px-2.5 py-1 rounded-full bg-white/3 border border-white/5 text-[10px] font-extrabold font-mono text-surface-300 hover:text-white hover:bg-white/10 transition-colors cursor-pointer"
                >
                  {recentCode}
                </button>
              ))}
            </div>
          </div>
        </form>
      </div>

      <div className="mt-6 pt-4 border-t border-white/5">
        <motion.button
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          onClick={handleSubmit}
          className="w-full py-3 rounded-xl bg-gradient-to-r from-purple-600 via-accent-500 to-blue-600 hover:from-purple-500 hover:to-blue-500 text-white font-black tracking-widest uppercase text-xs border border-purple-400/20 transition-all duration-300 shadow-glow-accent cursor-pointer flex items-center justify-center"
        >
          Join Room
        </motion.button>
      </div>
    </div>
  );
}
